<script lang="ts">
  import { MENUITEMS } from "../../Data/Layout/Sidebar";
  import FeatherIcon from "svelte-feather-icon";
  import { _ } from '../../i18n'
  import {sidebarClose,margin,sidebarClass} from "../../store";
  import UserDetail from "./UserDetail.svelte";
  import MenuList from "./MenuList.svelte";
  let y:number
  // siderbar is close and open
  let closer:boolean
  sidebarClose.subscribe((value:boolean) => {
    closer = value;
  });
  let setMargin:number
    margin.subscribe((value) => {
      setMargin = value
  })
  let setSiderbarClass:string
  sidebarClass.subscribe((value)=>{
    setSiderbarClass = value
  })
  const scrollToRight = () => {
    if (y < 1024) {
      margin.update((value) => (value += -800))
      if (setMargin < -5399) {
        document.querySelector('.right-arrow').classList.add('disabled')
      }
    } else if (y > 1023 && y < 1440) {
      margin.update((value) => (value += -1200))
      if (setMargin < -5399) {
        document.querySelector('.right-arrow').classList.add('disabled')
      }
    } else if (y > 1439) {
      margin.update((value) => (value += -1200))
      if (setMargin < -4799) {
        document.querySelector('.right-arrow').classList.add('disabled')
      }
    }
  }
  const scrollToLeft = () => {
    if (y < 1024) {
      margin.update((value) => (value -= -800))
      if (setMargin > -5399) {
        document.querySelector('.right-arrow').classList.remove('disabled')
      }
    } else if (y > 1023 && y < 1440) {
      margin.update((value) => (value -= -1200))
      if (setMargin > -5399) {
        document.querySelector('.right-arrow').classList.remove('disabled')
      }
    } else if (y > 1439) {
      margin.update((value) => (value -= -1200))
      if (setMargin > -4799) {
        document.querySelector('.right-arrow').classList.remove('disabled')
      }
    }
  }
</script>
<svelte:window bind:innerWidth={y} />
<header class="main-nav {y < 992 ? (closer ? '' : 'close_icon') : closer ? 'close_icon' : ''} ">
  <UserDetail />
  <nav>
    <div class="main-navbar" >
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <div class="left-arrow {setMargin === 0 ? 'disabled' : ''}" id="left-arrow" on:click={scrollToLeft} >
        <FeatherIcon icon="arrow-left" />
      </div>
      <div id="mainnav"  style="margin-Left :{setSiderbarClass
        .split(' ')   
        .includes('horizontal-wrapper') ? setMargin + 'px' : '0px'}">
        <ul class="nav-menu custom-scrollbar" style="display:block;">
          <li class="back-btn list-group-item">
            <div class="mobile-back text-end">
              <span>Back</span>
                <i class="fa fa-angle-right ps-2" />
            </div>
          </li>
          {#each MENUITEMS as mainMenu}
            <li class="sidebar-main-title">
              <div>
                  <h6>{$_(mainMenu.title)}</h6>
              </div>
            </li>
            <MenuList menu={mainMenu.menu} level={0}/>
          {/each}
        </ul>
      </div>
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <div class="right-arrow" id="right-arrow" on:click={scrollToRight}>
        <FeatherIcon icon="arrow-right" />
      </div>
    </div>
  </nav>
</header>

